
// Piki Candles theme — build v60 (2026-06) | see docs/V60-CHANGELOG.txt
// Announcement marquee — velocità/direzione configurabili. Scorre su mobile E desktop.
// Tecnica robusta: la durata è impostata INLINE con !important, così vince sulla regola globale
// prefers-reduced-motion (* {animation-duration:.001ms!important}) e la barra si muove davvero.
(function(){
  var m=document.querySelector('[data-piki-marquee]'); if(!m) return;
  var track=m.querySelector('.piki-marquee-track');
  var group=m.querySelector('.piki-marquee-group');
  if(!track || !group) return;
  var respectRM = m.getAttribute('data-respect-rm')==='true';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(respectRM && reduced) return; // il merchant ha scelto di rispettare "Riduci movimento" → il CSS la tiene ferma
  var speed = parseFloat(m.getAttribute('data-speed')); if(!speed || speed < 5) speed = 60; // px/secondo
  var dir = m.getAttribute('data-direction')==='right' ? 'reverse' : 'normal';
  function setSpeed(){
    var w=group.getBoundingClientRect().width; if(!w) return;
    var dur=Math.max(6, w/speed); // larghezza di un gruppo / px-al-secondo = secondi per scorrere di un gruppo
    track.style.setProperty('animation-name','pikiMarquee','important');
    track.style.setProperty('animation-timing-function','linear','important');
    track.style.setProperty('animation-iteration-count','infinite','important');
    track.style.setProperty('animation-direction',dir,'important');
    track.style.setProperty('animation-duration',dur.toFixed(2)+'s','important');
  }
  setSpeed();
  if(document.fonts && document.fonts.ready){ document.fonts.ready.then(setSpeed); } // ricalcola quando il font premium è caricato (desktop)
  var t; window.addEventListener('resize',function(){ clearTimeout(t); t=window.setTimeout(setSpeed,200); });
})();

document.addEventListener('submit', async (e)=>{
  const form=e.target.closest('form[data-ajax-cart="true"]');
  if(!form) return;
  e.preventDefault();
  const btn=form.querySelector('button[type="submit"]');
  const old=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='Aggiungo...'}
  try{
    const res=await fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
    if(!res.ok) throw new Error('cart');
    showPikiToast('Aggiunto al carrello');
    setTimeout(()=>{ window.location.href='/cart'; }, 650);
  }catch(err){ form.submit(); }
  finally{ if(btn){btn.disabled=false;btn.textContent=old} }
});
function showPikiToast(text){let t=document.querySelector('.piki-toast');if(!t){t=document.createElement('div');t.className='piki-toast';document.body.appendChild(t)}t.textContent=text;t.classList.add('show');setTimeout(()=>t.classList.remove('show'),1800)}
document.addEventListener('click',e=>{
  const choice=e.target.closest('[data-answer]');
  if(choice){e.preventDefault();var quiz=choice.closest('[data-piki-quiz]');var result=quiz.querySelector('.piki-quiz-result');var val=choice.dataset.answer;
    var copy={casa:['Candele per la casa','Fragranze avvolgenti in cera di soia per ogni ambiente.','/collections/candele-profumate-barattolo','Scopri le profumate'],regalo:['Idee regalo pronte','Le candele più amate, facili da scegliere e belle da donare.','/collections/best-seller-candele-profumate','Vedi i best seller'],evento:['Bomboniere personalizzate','Per matrimoni, battesimi, lauree ed eventi: proposta su misura.','/pages/bomboniere-candele-personalizzate','Scopri le bomboniere'],relax:['Momento relax','Profumazioni morbide e calde per camera e salotto.','/collections/candele-profumate-barattolo','Scegli la fragranza']};
    var f=copy[val]||copy.regalo;
    var title=choice.dataset.title||f[0], text=choice.dataset.text||f[1], href=choice.dataset.href||f[2], cta=choice.dataset.cta||f[3]||'Scopri la selezione';
    result.textContent='';
    var s=document.createElement('strong'); s.textContent=title;
    var p=document.createElement('p'); p.textContent=text;
    var a=document.createElement('a'); a.className='piki-btn dark'; a.setAttribute('href',href); a.textContent=cta;
    result.appendChild(s); result.appendChild(p); result.appendChild(a);
    result.classList.add('is-visible');
    var bar=quiz.querySelector('.piki-progress span'); if(bar) bar.style.width='100%';}
  const sticky=e.target.closest('[data-sticky-submit]');
  if(sticky){e.preventDefault();const form=document.querySelector('[data-main-product-form]'); if(form){ if(form.requestSubmit){ form.requestSubmit(); } else { form.submit(); } }}
});
// v48: variant option picker (swatch/pill) → updates id, price (all nodes), availability, gallery image
(function(){
  var root=document.querySelector('[data-product-options]');
  if(!root) return;
  var dataEl=root.querySelector('[data-variant-data]');
  var variants=[]; try{ variants=JSON.parse(dataEl.textContent); }catch(e){ return; }
  var idInput=root.querySelector('[data-variant-id]');
  var groups=[].slice.call(root.querySelectorAll('.piki-opt'));
  function chosen(){ return groups.map(function(g){ var b=g.querySelector('.piki-opt-btn.is-active'); return b?b.getAttribute('data-value'):null; }); }
  function apply(){
    var sel=chosen();
    var v=variants.filter(function(x){ return x.options.length===sel.length && x.options.every(function(o,i){ return o===sel[i]; }); })[0];
    if(!v) return;
    if(idInput) idInput.value=v.id;
    document.querySelectorAll('[data-current-price]').forEach(function(el){ el.textContent=v.price; });
    if(v.image){
      var main=document.querySelector('[data-gallery-main]');
      if(main){ main.removeAttribute('srcset'); main.src=v.image; }
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-full')===v.image); });
    }
    var atc=document.querySelector('[data-main-product-form] button[type="submit"]');
    if(atc){ atc.disabled=!v.available; atc.textContent=v.available?(atc.getAttribute('data-atc-label')||atc.textContent):'Non disponibile'; }
  }
  root.addEventListener('click',function(e){
    var btn=e.target.closest('.piki-opt-btn'); if(!btn) return;
    var grp=btn.closest('.piki-opt');
    grp.querySelectorAll('.piki-opt-btn').forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); });
    btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
    var row=btn.closest('.piki-opt-row'); if(row){ var lab=row.querySelector('[data-opt-current]'); if(lab) lab.textContent=btn.getAttribute('data-value'); }
    apply();
  });
  apply();
})();

// v41: product gallery — click a thumbnail to swap the main image
document.addEventListener('click',function(e){
  var thumb=e.target.closest('[data-gallery-thumb]');
  if(!thumb) return;
  var main=document.querySelector('[data-gallery-main]');
  var full=thumb.getAttribute('data-full');
  if(main&&full){ main.src=full; }
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(t){t.classList.remove('is-active');});
  thumb.classList.add('is-active');
});

// ===== v38: Mobile navigation drawer =====
(function(){
  var btn=document.querySelector('.piki-hamburger');
  var menu=document.querySelector('.piki-mobile-menu');
  if(!btn||!menu) return;
  var overlay=menu.querySelector('.piki-mobile-overlay');
  var closeBtn=menu.querySelector('.piki-mobile-close');
  var lastFocus=null;

  function openMenu(){
    lastFocus=document.activeElement;
    menu.classList.add('is-open');
    btn.setAttribute('aria-expanded','true');
    menu.removeAttribute('aria-hidden');
    document.body.style.overflow='hidden';
    setTimeout(function(){ if(closeBtn) closeBtn.focus(); },320);
  }
  function closeMenu(){
    menu.classList.remove('is-open');
    btn.setAttribute('aria-expanded','false');
    menu.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    if(lastFocus) lastFocus.focus();
  }

  btn.addEventListener('click',openMenu);
  if(closeBtn) closeBtn.addEventListener('click',closeMenu);
  if(overlay) overlay.addEventListener('click',closeMenu);

  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&menu.classList.contains('is-open')) closeMenu();
  });

  // Chiudi cliccando i link interni
  menu.querySelectorAll('.piki-mobile-nav a').forEach(function(link){
    link.addEventListener('click',function(){ closeMenu(); });
  });
})();

// v51: anti-bot honeypot — se il campo trappola è compilato, blocca l'invio
document.addEventListener('submit',function(e){
  var hp=e.target && e.target.querySelector ? e.target.querySelector('.piki-hp') : null;
  if(hp && hp.value){ e.preventDefault(); e.stopPropagation(); }
},true);

// v51: Piki Club popup — non invasivo, max una volta ogni 30 giorni (localStorage)
(function(){
  var pop=document.querySelector('[data-piki-popup]'); if(!pop) return;
  var KEY='pikiPopupSeen', NOW=Date.now(), DAYS=30;
  function open(){ pop.classList.add('is-open'); pop.setAttribute('aria-hidden','false'); }
  function close(){ pop.classList.remove('is-open'); pop.setAttribute('aria-hidden','true'); try{localStorage.setItem(KEY,String(NOW));}catch(e){} }
  if(pop.getAttribute('data-posted')==='true'){ try{localStorage.setItem(KEY,String(NOW));}catch(e){} open(); }
  else{
    var seen=0; try{seen=parseInt(localStorage.getItem(KEY)||'0',10);}catch(e){}
    if(!(seen && (NOW-seen) < DAYS*86400000)){
      var delay=(parseInt(pop.getAttribute('data-delay'),10)||7)*1000;
      window.setTimeout(open, delay);
    }
  }
  pop.addEventListener('click',function(e){ if(e.target.closest('[data-pop-close]')) close(); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape' && pop.classList.contains('is-open')) close(); });
  var f=pop.querySelector('form'); if(f) f.addEventListener('submit',function(){ try{localStorage.setItem(KEY,String(NOW));}catch(e){} });
})();

// ============================================================
// v55: micro-interazioni premium (elevazione header, scroll-reveal, hover prodotto)
// Tutto failsafe: se il JS non gira nulla resta nascosto; rispetta "Riduci movimento".
// ============================================================

// Header: ombra/elevazione discreta quando si scorre (look boutique, costo ~0)
(function(){
  var header=document.querySelector('.piki-header'); if(!header) return;
  var ticking=false;
  function onScroll(){
    if(ticking) return; ticking=true;
    window.requestAnimationFrame(function(){
      header.classList.toggle('is-scrolled', window.scrollY>6);
      ticking=false;
    });
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  onScroll();
})();

// Scroll-reveal: le sezioni entrano con una dissolvenza elegante mentre scorri.
// Niente flash sopra la piega: ciò che è già visibile al caricamento viene mostrato subito.
(function(){
  if(!('IntersectionObserver' in window)) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els=document.querySelectorAll('.piki-section,.piki-final-in,.piki-quote-page,.piki-details-copy,.piki-related,.piki-seo-body,.piki-desc-inner');
  if(!els.length) return;
  document.documentElement.classList.add('piki-reveal-on');
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
  },{rootMargin:'0px 0px -7% 0px',threshold:0.06});
  var vh=window.innerHeight||800;
  els.forEach(function(el){
    var r=el.getBoundingClientRect();
    if(r.top < vh*0.92){ el.classList.add('piki-reveal','is-in'); } // già in vista: nessuna animazione di entrata
    else { el.classList.add('piki-reveal'); io.observe(el); }
  });
})();

// Selettore lingua: invia il form al cambio (senza pulsante). Il <noscript> mostra "Vai" se JS è off.
document.addEventListener('change',function(e){
  var sel=e.target.closest('[data-piki-lang] select');
  if(sel && sel.form){ sel.form.submit(); }
});

// Card prodotto: seconda immagine al passaggio del mouse (solo desktop hover; su mobile non viene scaricata)
(function(){
  if(!(window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches)) return;
  document.querySelectorAll('.piki-photo[data-hover-src]').forEach(function(link){
    var alt=link.querySelector('.piki-photo-alt'); if(!alt) return;
    var loaded=false;
    link.addEventListener('pointerenter',function(){
      if(loaded) return; loaded=true;
      var ss=link.getAttribute('data-hover-srcset'); if(ss) alt.setAttribute('srcset', ss);
      alt.setAttribute('src', link.getAttribute('data-hover-src'));
    });
  });
})();

// v58: barra acquisto fissa (mobile) — nascondi finché il pulsante principale è in vista,
// così non si sovrappone al carrello già visibile nel box. Senza IntersectionObserver resta sempre mostrata.
(function(){
  var bar=document.querySelector('.piki-sticky-atc'); if(!bar) return;
  if(!('IntersectionObserver' in window)) return;
  var main=document.querySelector('[data-main-product-form] button[type="submit"]'); if(!main) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(en){ bar.classList.toggle('is-hidden', en.isIntersecting); });
  },{rootMargin:'0px 0px -25% 0px'});
  io.observe(main);
})();
